/**
 *
 *
 *
 *
 *
 *
 */
import { o_util } from "@gr-common/body/namespaces";
import { otto } from "@gr-exports/body/nexus";
import { noop } from "@gr-common/body/function";
/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
/*                      */
export const asExport = (namespace, fieldKey, defaultValue) => (namespace[fieldKey] ?? defaultValue);
/**
 *
 */
export const core = asExport(o_util, "core", {});
/**
 *
 *
 *
 */
export const isEmptyObject = asExport(core, "isEmptyObject", noop);
/**
 *
 *
 *
 */
export const isPlainObject = asExport(core, "isPlainObject", noop);
/**
 *
 *
 *
 */
export const withMacrotask = asExport(core, "withMacrotask", noop);
/**
 *
 *
 *
 *
 */
export const withRenderSlice = asExport(core, "withRenderSlice", noop);
/**
 *
 */
export const coreasync = asExport(otto, "grcore", {});
/**
 *
 *
 *
 */
export const runWithMicrotask = asExport(coreasync, "runWithMicrotask", noop);
/**
 *
 *
 *
 */
export const runWithMacrotask = asExport(coreasync, "runWithMacrotask", noop);
/**
 *
 *
 *
 */
export const runWithAnimationFrame = asExport(coreasync, "runWithAnimationFrame", noop);
/**
 *
 *
 *
 */
export const runWithRenderSlice = asExport(coreasync, "runWithRenderSlice", noop);
///
/*                    */
///
/**
 *
 *
 *
 */
export const coerce = asExport(core, "coerce", noop);
/**
 *
 *
 *
 */
export const deserialize = asExport(core, "deserialize", noop);
/**
 *
 *
 *
 */
export const serialize = asExport(core, "serialize", noop);
/**
 *
 *
 *
 */
export const serializeForm = asExport(core, "serializeForm", noop);
